interface ShopWarningIconProps {
    color?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

const ShopWarningIcon = ({ className, color = 'currentColor', width = 50, height = 50, svgProps }: ShopWarningIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 50 50" fill="none" className={className} {...svgProps}>
            <rect x="24.75" y="1.41421" width="33" height="33" rx="5" transform="rotate(45 24.75 1.41421)" stroke={color} strokeWidth="2" />
            <rect x="24.5" y="16.5" width="1" height="11" stroke={color} />
            <rect x="24.5" y="31.5" width="1" height="1" stroke={color} />
        </svg>
    );
};

export default ShopWarningIcon;
